import { useEditMerchantNotification } from 'pages/Merchants/MerchantsShow/MerchantsShowNotifications/hooks/useEditMerchantNotification';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { Card, CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { MerchantNotification } from 'types/embedded/merchantNotification';

type Props = {
  onClose: VoidFunction;
  notification: MerchantNotification;
} & DialogProps;

export const MerchantsShowNotificationsDeliveryChannelActivityFieldSwitchConfirmOn: React.FC<
  Props
> = ({ open, onClose, notification }) => {
  const translate = useTypedTranslate();

  const { isLoading, mutate } = useEditMerchantNotification(notification.id, () => {
    onClose();
    queryClient.invalidateQueries({ queryKey: ['merchant_notification_settings'] });
  });

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title={translate('app.merchantsShowNotifications.enableNotificationSettings')}
          titleSize="smallBold"
        />
        <CardContent>
          <Typography>
            {translate('app.merchantsShowNotifications.notificationWillBeTemporarily1')}{' '}
            <TypographyBold fontSize={16} text={`ID ${notification.id}`} />{' '}
            {translate('app.merchantsShowNotifications.notificationWillBeTemporarily2')}
          </Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton
              key="cancel-button"
              label={translate('app.buttons.cancel')}
              onClick={onClose}
              variant="outlined"
            />,
            <Button
              isLoading={isLoading}
              key="save-button"
              label={translate('app.buttons.confirm')}
              onClick={() => mutate({ active: true })}
              variant="contained"
            />,
          ]}
        />
      </Card>
    </Dialog>
  );
};
